import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { TransactionStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('transaction', reducer),
        EffectsModule.forFeature([TransactionStoreEffects])
    ],
    providers: []
})
export class TransactionStoreModule {}
